import { Button, Empty } from 'antd'
import React, { useState } from 'react'
import { useTranslation } from 'next-i18next'
import { integrationStaticsSelector } from 'src/features'
import { CustomTable, CustomTitle } from 'src/components'
import { CloudDownloadOutlined } from '@ant-design/icons'
import { useAppSelector, useWindowSize } from 'src/app/hooks'
import { successOffsetsColumns } from 'src/core/table-columns'
import { exportPdfZip, getActualDateFormated } from 'src/core/helpers'

interface SuccessPurchasesContentProps { purchasesResults: any }

const SuccessPurchasesContent: React.FC<SuccessPurchasesContentProps> = ({ purchasesResults }) => {
  const { t } = useTranslation()
  const { isMobile } = useWindowSize()
  const [isLoading, setIsLoading] = useState(false)
  const { data: { integration_code } } = useAppSelector(integrationStaticsSelector)

  const certificates: { name: string, url: string }[] = purchasesResults?.map((item: any) => {
    const name = `${item?.project_name}_${item?.extra_data?.transaction_identifier}`
    return { name, url: item?.certificate }
  })

  const handleDownload = async () => {
    setIsLoading(true)
    const fileName = `${integration_code?.toLowerCase()}_${getActualDateFormated()}`
    await exportPdfZip(fileName, certificates)
    setIsLoading(false)
  }

  return <>
    {purchasesResults.length === 0 ? (
      <Empty description={<CustomTitle label={t('developers.OffSet.PurchasesLabel')} />} />
    ) : <>
      <CustomTable
        columns={successOffsetsColumns}
        dataSource={purchasesResults}
      />
      <Button
        size='middle'
        type='dashed'
        block={isMobile}
        loading={isLoading}
        onClick={handleDownload}
        icon={<CloudDownloadOutlined />}
        className='float-right radius-100 mb-5'
      >{t('general.DownloadAll')}
      </Button>
    </>}
  </>
}

export default SuccessPurchasesContent
